export function incrementRecursive(items: any[], rootLevel = "1") {
  // for (let i = 0; i < items.length; i++) {
  //   const item = items[i];

  //   const splits = rootLevel.split(".");

  //   const last: any = splits.pop();

  //   const inc = +last + i;

  //   splits.push(`${inc}`);

  //   const nextCode = splits.join(".");

  //   item.breadcrumb = `${nextCode}`;

  //   item.items = incrementRecursive(item.items, `${nextCode}.1`);
  // }

  return items;
}

